export const maximumNumber = (value: number, max: number | null, type: 'hint' | 'error' = 'error', message?: string) => {
  if (max === null) {
    return { isValid: true, message: null }
  }

  const isValid = type === 'hint' ? value < max : value <= max
  return {
    isValid,
    message: isValid ? null : message || `Value must be less than or equal to ${max}`,
  }
}

export const minimumNumber = (value: number, min: number, message?: string) => {
  if (value === 0 || value >= min) {
    return { isValid: true, message: null }
  }
  return { isValid: false, message: message || `Value must be greater than or equal to ${min}` }
}

export const isMultipleOf = (value: number, multiplier: number | null, message?: string) => {
  if (multiplier === null || value % multiplier === 0) {
    return { isValid: true, message: null }
  }
  return { isValid: false, message: message || `Value must be a multiple of ${multiplier}` }
}
